var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caret left"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2404 6.74279C14.5865 7.06651 14.5865 7.59138 14.2404 7.9151L10.1399 11.75L14.2404 15.585C14.5865 15.9087 14.5865 16.4335 14.2404 16.7572C13.8942 17.0809 13.3331 17.0809 12.9869 16.7572L8.25961 12.3361C7.91346 12.0124 7.91346 11.4876 8.25961 11.1639L12.9869 6.74279C13.3331 6.41907 13.8942 6.41907 14.2404 6.74279Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.a327f503c862394fa13b17ab9246e798.svg";
export { ForwardRef as ReactComponent };